import _defineProperty from "@babel/runtime/helpers/defineProperty";
//
// Copyright IBM Corp. 2020, 2021
//
// This source code is licensed under the Apache-2.0 license found in the
// LICENSE file in the root directory of this source tree.
//
import React from 'react';
import cx from 'classnames';
import { Button } from 'carbon-components-react';
import PropTypes from 'prop-types';
import { pkg } from '../../settings';
var componentName = 'CardFooter';
var defaults = {
  actions: Object.freeze([]),
  primaryButtonKind: 'primary',
  productive: false,
  secondaryButtonKind: 'secondary'
};
export var CardFooter = function CardFooter(_ref) {
  var _ref$actions = _ref.actions,
      actions = _ref$actions === void 0 ? defaults.actions : _ref$actions,
      hasActions = _ref.hasActions,
      hasButton = _ref.hasButton,
      onPrimaryButtonClick = _ref.onPrimaryButtonClick,
      onSecondaryButtonClick = _ref.onSecondaryButtonClick,
      primaryButtonHref = _ref.primaryButtonHref,
      primaryButtonIcon = _ref.primaryButtonIcon,
      _ref$primaryButtonKin = _ref.primaryButtonKind,
      primaryButtonKind = _ref$primaryButtonKin === void 0 ? defaults.primaryButtonKind : _ref$primaryButtonKin,
      primaryButtonPlacement = _ref.primaryButtonPlacement,
      primaryButtonText = _ref.primaryButtonText,
      _ref$productive = _ref.productive,
      productive = _ref$productive === void 0 ? defaults.productive : _ref$productive,
      secondaryButtonHref = _ref.secondaryButtonHref,
      secondaryButtonIcon = _ref.secondaryButtonIcon,
      _ref$secondaryButtonK = _ref.secondaryButtonKind,
      secondaryButtonKind = _ref$secondaryButtonK === void 0 ? defaults.secondaryButtonKind : _ref$secondaryButtonK,
      secondaryButtonText = _ref.secondaryButtonText;
  var blockClass = "".concat(pkg.prefix, "--card");
  var footerClass = "".concat(pkg.prefix, "--card__footer");
  var footerClasses = cx(footerClass, _defineProperty({}, "".concat(footerClass, "-no-button"), !hasButton));
  return /*#__PURE__*/React.createElement("div", {
    className: footerClasses
  }, secondaryButtonText && /*#__PURE__*/React.createElement(Button, {
    kind: secondaryButtonKind,
    onClick: onSecondaryButtonClick,
    size: "field",
    renderIcon: secondaryButtonIcon,
    href: secondaryButtonHref
  }, secondaryButtonText), primaryButtonText && primaryButtonPlacement === 'bottom' && /*#__PURE__*/React.createElement(Button, {
    kind: productive ? 'ghost' : primaryButtonKind,
    onClick: onPrimaryButtonClick,
    size: "field",
    renderIcon: primaryButtonIcon,
    href: primaryButtonHref
  }, primaryButtonText), hasActions && /*#__PURE__*/React.createElement("div", {
    className: "".concat(blockClass, "__actions")
  }, actions));
};
CardFooter.propTypes = {
  actions: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
  hasActions: PropTypes.bool,
  hasButton: PropTypes.bool,
  onPrimaryButtonClick: PropTypes.func,
  onSecondaryButtonClick: PropTypes.func,
  primaryButtonHref: PropTypes.string,
  primaryButtonIcon: PropTypes.string,
  primaryButtonKind: PropTypes.oneOf(['primary', 'ghost']),
  primaryButtonPlacement: PropTypes.oneOf(['top', 'bottom']),
  primaryButtonText: PropTypes.string,
  productive: PropTypes.bool,
  secondaryButtonHref: PropTypes.string,
  secondaryButtonIcon: PropTypes.string,
  secondaryButtonKind: PropTypes.oneOf(['secondary', 'ghost']),
  secondaryButtonText: PropTypes.string
};
CardFooter.displayName = componentName;